export type FAQItem = {
    questionKey: string;
    answerKey: string;
};

/** FAQ questions in display order: the FAQ section and the device-view FAQ window both read this list. */
export const FAQ_ITEMS: ReadonlyArray<FAQItem> = [
    {
        questionKey: "faq.availability.question",
        answerKey: "faq.availability.answer",
    },
    {
        questionKey: "faq.startups.question",
        answerKey: "faq.startups.answer",
    },
    {
        questionKey: "faq.rates.question",
        answerKey: "faq.rates.answer",
    },
    {
        questionKey: "faq.maintenance.question",
        answerKey: "faq.maintenance.answer",
    },
    {
        questionKey: "faq.timeline.question",
        answerKey: "faq.timeline.answer",
    },
    {
        questionKey: "faq.remote.question",
        answerKey: "faq.remote.answer",
    },
    {
        questionKey: "faq.industries.question",
        answerKey: "faq.industries.answer",
    },
    {
        questionKey: "faq.employment.question",
        answerKey: "faq.employment.answer",
    },
    {
        questionKey: "faq.noticePeriod.question",
        answerKey: "faq.noticePeriod.answer",
    },
    {
        questionKey: "faq.relocation.question",
        answerKey: "faq.relocation.answer",
    },
];
